import { AfterContentInit, Directive, ElementRef, Input } from '@angular/core';

@Directive({
    selector: '[appSelectAccessibility]',
})
// todo: check maybe ng-select already has something for accessibility
export class SelectAccessibilityDirective implements AfterContentInit {
    @Input() inputAriaLabelAttribute = 'combobox';

    public constructor(private el: ElementRef) {}

    public ngAfterContentInit() {
        const inputInside = this.el.nativeElement.querySelector('input[autocomplete]');
        inputInside.setAttribute('autocomplete', 'off');
        inputInside.setAttribute('aria-label', this.inputAriaLabelAttribute);
    }
}
